let productObj = [
    {
        "id":10000,
        "catName":"汽车车牌识别系统",
        "catUrl":"/Car-Plate-License-Recognition-System--163123980284700.html",
        "webUrl":"",
        "sort":0,
        "catList":[
        {
            "id":1251,
            "catName":"YF-ARC Series",
            "catUrl":"/YF-ARC-Series-1631241438112.html",
            "webUrl":"",
            "sort":0,
            "catList":[],
            "shopList":[
            // {
            // "name":" Plate License Recognition System YF-ARC-C02",
            // "img":"16_dc06478721034ffa83171ab3db0d8459.png",
            // "id":3106,
            // "url":"",
            // "webUrl":null,
            // "pId":null,
            // "sort":1,
            // "keyWords":[
            // ],
            // "describe":null,
            // "skus":null,
            // "sonList":null
            //},
            {
            "name":" ARC-D004",
            "img":"tu1.png",
            "id":112512,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":1,
            "keyWords":[
            ],
            "describe":"Using the latest research and development of Brushless DC motor, stable operation, long service life.The landing speed is adjustable for 1.5-4 seconds.It can be interchanged between left and right.Curved arm four-bar movement structure, stable landing rod.Wireless remote control for pole lifting and pole dropping.Return in case of resistance (force adjustable).Delay rod drop function.It has the function of delay automatic closing.",
            "skus":null,
            "sonList":null
            },
            {
            "name":" ARC-D005",
            "img":"tu2.png",
            "id":112513,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":1,
            "keyWords":[
            ],
            "describe":"Using the latest research and development of Brushless DC motor, stable operation, long service life.The landing speed is adjustable for 1.5-4 seconds.It can be interchanged between left and right.Curved arm four-bar movement structure, stable landing rod.Wireless remote control for pole lifting and pole dropping.Return in case of resistance (force adjustable).Delay rod drop function.It has the function of delay automatic closing.",
            "skus":null,
            "sonList":null
            },
            {
            "name":"YF-ARC-R01",
            "img":"tu52.jpg",
            "id":112516,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":1,
            "keyWords":[
            ],
            "describe":`1. Pre installed in the integrated machine.
            2.Four languages are available, including Thai, Chinese, English and Spanish.
            3.Simple interface, easy to learn and use`,
            "skus":null,
            "sonList":null
            },
            {
            "name":"4K Smart Android Box",
            "img":"图片53.jpg",
            "id":112516,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":1,
            "keyWords":[
            ],
            "describe":"",
            "skus":null,
            "sonList":null
            },
            {
            "name":" ARC-P003",
            "img":"图片3.png",
            "id":112514,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":1,
            "keyWords":[
            ],
            "describe":"support license plate types in more than 20 countries adjustable high or low voice, adjustable for male and female automatic night light switching display brightness self-adjusting camera 135 degree adjustment",
            "skus":null,
            "sonList":null
            },
            {
            "name":" ARC-P005",
            "img":"tu4.png",
            "id":112515,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":1,
            "keyWords":[
            ],
            "describe":"support license plate types in more than 20 countries adjustable high or low voice, adjustable for male and female automatic night light switching display brightness self-adjusting camera 135 degree adjustment",
            "skus":null,
            "sonList":null
            },
            // {
            // "name":" Monitoring equipment",
            // "img":"图片6.png",
            // "id":112517,
            // "url":"",
            // "webUrl":null,
            // "pId":null,
            // "sort":1,
            // "keyWords":[
            // ],
            // "describe":"Equipped with ICE high-precision license plate recognition algorithm, it supports license plate recognition in various harsh environments such as large angle, forward and backward light,the license plate is inconsistent with the front and rear of the vehicle, rain and snow weather, and is leading in the industry in recognition speed, recognition type and accuracy support video unlicensed vehicle detection and non motor vehicle filtering support unlicensed vehicle identification and feature code comparisonsupport 11 types of vehicle identification",
            // "skus":null,
            // "sonList":null
            // },
            {
            "name":"Plate License Recognition System YF-ARC-P001",
            "img":"16_a7eeb3cc5b0f4a7ca4b9f1fd63affc00.png",
            "id":3108,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":0,
            "keyWords":[
            ],
            "describe":null,
            "skus":null,
            "sonList":null
            },
            {
            "name":"Plate License Recognition System YF-ARC-P002",
            "img":"16_cf962c90a2b648a5934e958cc6c8665e.png",
            "id":3109,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":0,
            "keyWords":[
            ],
            "describe":null,
            "skus":null,
            "sonList":null
            },
            {
            "name":"Plate License Recognition System YF-ARC-P003",
            "img":"16_ec4bd9ce005c4ffb98351104c98ba059.png",
            "id":3110,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":0,
            "keyWords":[
            ],
            "describe":null,
            "skus":null,
            "sonList":null
            },
            {
            "name":" Plate License Recognition System YF-ARC-S01",
            "img":"16_67edda709edd4e649da370332b14b30f.png",
            "id":3459,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":0,
            "keyWords":[
            ],
            "describe":null,
            "skus":null,
            "sonList":null
            },
            {
            "name":" Plate License Recognition System YF-ARC-S02",
            "img":"16_5abd576c39ab48dc8c5ecf43a306879f.png",
            "id":3460,
            "url":"",
            "webUrl":null,
            "pId":null,
            "sort":0,
            "keyWords":[
            ],
            "describe":null,
            "skus":null,
            "sonList":null
            }
            ],
            "img":"",
            "seoTitle":null,
            "seoKeyWords":null,
            "seoDescription":null,
            "pid":1247
        },  
        // {
        //     "id":11251,
        //     "catName":"ANPR Car License Plate Recognition System",
        //     "catUrl":"/YF-ARC-Series-163124143811210.html",
        //     "webUrl":"",
        //     "sort":0,
        //     "catList":[],
        //     "shopList":[
        //     {
        //     "name":" ARC-D004",
        //     "img":"tu1.png",
        //     "id":112512,
        //     "url":"",
        //     "webUrl":null,
        //     "pId":null,
        //     "sort":1,
        //     "keyWords":[
        //     ],
        //     "describe":"Using the latest research and development of Brushless DC motor, stable operation, long service life.The landing speed is adjustable for 1.5-4 seconds.It can be interchanged between left and right.Curved arm four-bar movement structure, stable landing rod.Wireless remote control for pole lifting and pole dropping.Return in case of resistance (force adjustable).Delay rod drop function.It has the function of delay automatic closing.",
        //     "skus":null,
        //     "sonList":null
        //     },
        //     {
        //     "name":" ARC-D005",
        //     "img":"tu2.png",
        //     "id":112513,
        //     "url":"",
        //     "webUrl":null,
        //     "pId":null,
        //     "sort":1,
        //     "keyWords":[
        //     ],
        //     "describe":"Using the latest research and development of Brushless DC motor, stable operation, long service life.The landing speed is adjustable for 1.5-4 seconds.It can be interchanged between left and right.Curved arm four-bar movement structure, stable landing rod.Wireless remote control for pole lifting and pole dropping.Return in case of resistance (force adjustable).Delay rod drop function.It has the function of delay automatic closing.",
        //     "skus":null,
        //     "sonList":null
        //     },
        //     {
        //     "name":" Intelligent parking management system",
        //     "img":"图片52.jpg",
        //     "id":112516,
        //     "url":"",
        //     "webUrl":null,
        //     "pId":null,
        //     "sort":1,
        //     "keyWords":[
        //     ],
        //     "describe":`The cloud computing person-vehicle access management system designed by Yufei Intelligent Communication completely solves the huge problem brought by computer and LAN to the system
        //     Trouble, to minimize after-sales service costs. At the same time, it also greatly reduces the construction cost and management cost of access management equipment.
        //     Relying on the design architecture of cloud computing + Internet of Things, Yufei Intelligent Passage has built a set of full-scene management platform for pedestrian and vehicle access, including: stop
        //     Car park license plate recognition management system, access control management system, pedestrian channel management system and parking management system. To: "Centralized management, cloud application"
        //     A new concept to provide a full range of city-level parking management and operation services for the era of big data`,
        //     "skus":null,
        //     "sonList":null
        //     },
        //     {
        //     "name":"4K Smart Android Box",
        //     "img":"图片53.jpg",
        //     "id":112516,
        //     "url":"",
        //     "webUrl":null,
        //     "pId":null,
        //     "sort":1,
        //     "keyWords":[
        //     ],
        //     "describe":"",
        //     "skus":null,
        //     "sonList":null
        //     },
        //     {
        //     "name":" ARC-P003",
        //     "img":"图片3.png",
        //     "id":112514,
        //     "url":"",
        //     "webUrl":null,
        //     "pId":null,
        //     "sort":1,
        //     "keyWords":[
        //     ],
        //     "describe":"support license plate types in more than 20 countries adjustable high or low voice, adjustable for male and female automatic night light switching display brightness self-adjusting camera 135 degree adjustment",
        //     "skus":null,
        //     "sonList":null
        //     },
        //     {
        //     "name":" ARC-P005",
        //     "img":"tu4.png",
        //     "id":112515,
        //     "url":"",
        //     "webUrl":null,
        //     "pId":null,
        //     "sort":1,
        //     "keyWords":[
        //     ],
        //     "describe":"support license plate types in more than 20 countries adjustable high or low voice, adjustable for male and female automatic night light switching display brightness self-adjusting camera 135 degree adjustment",
        //     "skus":null,
        //     "sonList":null
        //     },
        //     {
        //     "name":" Monitoring equipment",
        //     "img":"图片6.png",
        //     "id":112517,
        //     "url":"",
        //     "webUrl":null,
        //     "pId":null,
        //     "sort":1,
        //     "keyWords":[
        //     ],
        //     "describe":"Equipped with ICE high-precision license plate recognition algorithm, it supports license plate recognition in various harsh environments such as large angle, forward and backward light,the license plate is inconsistent with the front and rear of the vehicle, rain and snow weather, and is leading in the industry in recognition speed, recognition type and accuracy support video unlicensed vehicle detection and non motor vehicle filtering support unlicensed vehicle identification and feature code comparisonsupport 11 types of vehicle identification",
        //     "skus":null,
        //     "sonList":null
        //     }
        // ],
        //     "img":"",
        //     "seoTitle":null,
        //     "seoKeyWords":null,
        //     "seoDescription":null,
        //     "pid":11251
        // },
        // {
        //     "id":11252,
        //     "catName":"Parking Guidance System",
        //     "catUrl":"/YF-ARC-Series-1631241438112.html",
        //     "webUrl":"",
        //     "sort":0,
        //     "catList":[],
        //     "shopList":[
        //         {
        //             "name":"Parking Camera",
        //             "img":"tu7.png",
        //             "id":112521,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Integrating detection, indication of parking space status, recognition of license plates, and monitoring of vehicle status; It can detect 1-6 parking spaces and supports POE switches or external power supply hand in hand power supply networking, saving construction costs.",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-FLA-X04",
        //             "img":"tu9.png",
        //             "id":112523,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Display empty parking spaces in the garage, including advertising spaces, without pillars P10 surface mount module, red and green dual color, outdoor highlight, tempered glass panel Highlighted LED display, far visible distance, IP65 protection level supports indoor use",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YE-ELA-C03",
        //             "img":"tu10.png",
        //             "id":112524,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Display information such as empty parking spaces in the garage, maps, payment QR codes, etc., including advertising spaces, without pillars P10 surface mount module, red and green dual color, outdoor highlight, tempered glass panel  Highlighted LED display, far visible distance, IP65 protection level supports indoor use",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-STAR-X05",
        //             "img":"tu8.png",
        //             "id":112522,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Display empty parking spaces in the garage, including advertising spaces, without pillars P10 surface mount module, red and green dual color, outdoor highlight, tempered glass panel Highlighted LED display, far visible distance, IP65 protection level supports outdoor use",
        //             "skus":null,
        //             "sonList":null
        //             },
        //     ],
        //     "img":"",
        //     "seoTitle":null,
        //     "seoKeyWords":null,
        //     "seoDescription":null,
        //     "pid":1247
        // },
        // {
        //     "id":11253,
        //     "catName":"On Road Parking System",
        //     "catUrl":"/YF-ARC-Series-16312414381128.html",
        //     "webUrl":"",
        //     "sort":0,
        //     "catList":[],
        //     "shopList":[
        //         {
        //             "name":"YF-ARC-ORC1",
        //             "img":"tu11.png",
        //             "id":112531,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Resolution: 8 million (3840 * 2160) Lens: 10~40mm manual zoom Applicable scenario: High level positive/high level oblique/medium level positive/medium level oblique Management berth: 8 parallel berths, recommended 7 berths (3+4), with a maximum of 3+3 oblique lighting Capture rate: ≥ 95% Recognition rate: ≥ 98%Multiple detection rate: ≤ 2%",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-ARC-ORDC1",
        //             "img":"tu12.png",
        //             "id":112532,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Resolution: 5 million (2592 * 1920) Lens: 6-22mm, 12-40mm, manual zoom Applicable scenario: High level front view/medium level front view Management of berths: 7-8 parallel berths for direct lighting, 6 berths (3+3) recommended, not recommended for oblique lighting scenarios Capture rate: ≥ 95% Recognition rate: ≥ 98% Multiple detection rate: ≤ 2%",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-ARC-ORBC1",
        //             "img":"tu13.png",
        //             "id":112533,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Resolution: 2 million (1920 * 1080) Lens: 5.1-114.4mm electric zoom Applicable scenario: High level vertical/inclined berthing Management of berths: Supports up to 14 vertical berths, recommends<3 preset berths,<9 berths (3+3+3) Protection level: IP67 Capture rate: ≥ 90% Recognition rate: ≥ 98%Multiple inspection rate: ≤ 10%",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-ARC-ORC2",
        //             "img":"图片14.png",
        //             "id":112534,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Resolution: 5 million (2592 * 1920) Lens: 5-50mm manual zoom Applicable scenario: High level positive/high level oblique/medium level positive/medium level oblique Management berths: 7-8 parallel berths, recommended 6 berths (3+3), with up to 3+3 oblique lighting Capture rate: ≥ 95%Recognition rate: ≥ 98% Multiple detection rate: ≤ 2%",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-ARC-VS1A",
        //             "img":"tu18.png",
        //             "id":112535,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Resolution: 2 million (1920 * 1080) Applicable scenario: Low parallel/vertical Manage Berths: Single Berth Power supply method: Wide voltage 8-26V, 24V/16.6A switch power supply, up to 20 video stations for power supplyNetworking method: Double port hand in hand networking, supporting Bypass Indicator light: 6-color indicator light Abnormal alarm: cross position, line pressing, non motorized vehicle occupancy, unlicensed vehicle occupancy, video obstruction, reverse parking Protection level: IP66 Capture rate: 98% Recognition rate: 98%",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-ARC-VS1B",
        //             "img":"tu18.png",
        //             "id":112536,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":"Resolution: 2 million (1920 * 1080) Applicable scenario: Low parallel/vertical Manage Berths: Single Berth Power supply method: Wide voltage 8-26V, 24V/16.6A switch power supply, up to 20 video stations for power supplyNetworking method: Double port hand in hand networking, supporting Bypass Indicator light: 6-color indicator light Abnormal alarm: cross position, line pressing, non motorized vehicle occupancy, unlicensed vehicle occupancy, video obstruction, reverse parking Protection level: IP66 Capture rate: 98% Recognition rate: 98%",
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-ARC-VS1B",
        //             "img":"tu18.png",
        //             "id":112537,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":null,
        //             "skus":null,
        //             "sonList":null
        //             },
        //             {
        //             "name":"YF-ARC-VS1B",
        //             "img":"图片18.png",
        //             "id":112538,
        //             "url":"",
        //             "webUrl":null,
        //             "pId":null,
        //             "sort":1,
        //             "keyWords":[
        //             ],
        //             "describe":null,
        //             "skus":null,
        //             "sonList":null
        //             },
        //     ],
        //     "img":"",
        //     "seoTitle":null,
        //     "seoKeyWords":null,
        //     "seoDescription":null,
        //     "pid":1247
        // }
    ],
        "shopList":[],
        "img":"",
        "seoTitle":null,
        "seoKeyWords":null,
        "seoDescription":null,
        "pid":0
    },

    {
        "id":13500,
        "catName":"车位引导系统",
        "catUrl":"/Bollard-Barrier-1611805551674.html",
        "webUrl":"",
        "sort":1,
        "catList":[
        {
        "id":13600,
        "catName":"YF-PLA Series",
        "catUrl":"/YF-ROC-1611805574889.html",
        "webUrl":"",
        "sort":0,
        "catList":[
        ],
        "shopList":[
            {
                "name":"YF-PLA-CAM1",
                "img":"tu7.png",
                "id":112521,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Integrating detection, indication of parking space status, recognition of license plates, and monitoring of vehicle status; It can detect 1-6 parking spaces and supports POE switches or external power supply hand in hand power supply networking, saving construction costs.",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-PLA-YWP1",
                "img":"tu9.png",
                "id":112523,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Display empty parking spaces in the garage, including advertising spaces, without pillars P10 surface mount module, red and green dual color, outdoor highlight, tempered glass panel Highlighted LED display, far visible distance, IP65 protection level supports indoor use",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-PLA-CXM1",
                "img":"tu10.png",
                "id":112524,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Display information such as empty parking spaces in the garage, maps, payment QR codes, etc., including advertising spaces, without pillars P10 surface mount module, red and green dual color, outdoor highlight, tempered glass panel  Highlighted LED display, far visible distance, IP65 protection level supports indoor use",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-PLA-ZYW1",
                "img":"tu8.png",
                "id":112522,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Display empty parking spaces in the garage, including advertising spaces, without pillars P10 surface mount module, red and green dual color, outdoor highlight, tempered glass panel Highlighted LED display, far visible distance, IP65 protection level supports outdoor use",
                "skus":null,
                "sonList":null
                },
        ],
        "img":"",
        "seoTitle":null,
        "seoKeyWords":null,
        "seoDescription":null,
        "pid":135
        }
        ],
        "shopList":[
        ],
        "img":"",
        "seoTitle":null,
        "seoKeyWords":null,
        "seoDescription":null,
        "pid":0
    },

    {
        "id":14500,
        "catName":"路边停车系统",
        "catUrl":"/Bollard-Barrier-1611805551674.html",
        "webUrl":"",
        "sort":1,
        "catList":[
        {
        "id":14600,
        "catName":"YF-ARC",
        "catUrl":"/YF-ROC-1611805574889.html",
        "webUrl":"",
        "sort":0,
        "catList":[
        ],
        "shopList":[
            {
                "name":"YF-ARC-ORC1",
                "img":"tu11.png",
                "id":112531,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Resolution: 8 million (3840 * 2160) Lens: 10~40mm manual zoom Applicable scenario: High level positive/high level oblique/medium level positive/medium level oblique Management berth: 8 parallel berths, recommended 7 berths (3+4), with a maximum of 3+3 oblique lighting Capture rate: ≥ 95% Recognition rate: ≥ 98%Multiple detection rate: ≤ 2%",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-ARC-ORDC1",
                "img":"tu12.png",
                "id":112532,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Resolution: 5 million (2592 * 1920) Lens: 6-22mm, 12-40mm, manual zoom Applicable scenario: High level front view/medium level front view Management of berths: 7-8 parallel berths for direct lighting, 6 berths (3+3) recommended, not recommended for oblique lighting scenarios Capture rate: ≥ 95% Recognition rate: ≥ 98% Multiple detection rate: ≤ 2%",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-ARC-ORBC1",
                "img":"tu13.png",
                "id":112533,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Resolution: 2 million (1920 * 1080) Lens: 5.1-114.4mm electric zoom Applicable scenario: High level vertical/inclined berthing Management of berths: Supports up to 14 vertical berths, recommends<3 preset berths,<9 berths (3+3+3) Protection level: IP67 Capture rate: ≥ 90% Recognition rate: ≥ 98%Multiple inspection rate: ≤ 10%",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-ARC-ORC2",
                "img":"图片14.png",
                "id":112534,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Resolution: 5 million (2592 * 1920) Lens: 5-50mm manual zoom Applicable scenario: High level positive/high level oblique/medium level positive/medium level oblique Management berths: 7-8 parallel berths, recommended 6 berths (3+3), with up to 3+3 oblique lighting Capture rate: ≥ 95%Recognition rate: ≥ 98% Multiple detection rate: ≤ 2%",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-ARC-VS1A",
                "img":"tu18.png",
                "id":112535,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Resolution: 2 million (1920 * 1080) Applicable scenario: Low parallel/vertical Manage Berths: Single Berth Power supply method: Wide voltage 8-26V, 24V/16.6A switch power supply, up to 20 video stations for power supplyNetworking method: Double port hand in hand networking, supporting Bypass Indicator light: 6-color indicator light Abnormal alarm: cross position, line pressing, non motorized vehicle occupancy, unlicensed vehicle occupancy, video obstruction, reverse parking Protection level: IP66 Capture rate: 98% Recognition rate: 98%",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-ARC-VS1B",
                "img":"tu18.png",
                "id":112536,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":"Resolution: 2 million (1920 * 1080) Applicable scenario: Low parallel/vertical Manage Berths: Single Berth Power supply method: Wide voltage 8-26V, 24V/16.6A switch power supply, up to 20 video stations for power supplyNetworking method: Double port hand in hand networking, supporting Bypass Indicator light: 6-color indicator light Abnormal alarm: cross position, line pressing, non motorized vehicle occupancy, unlicensed vehicle occupancy, video obstruction, reverse parking Protection level: IP66 Capture rate: 98% Recognition rate: 98%",
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-ARC-VS1B",
                "img":"tu18.png",
                "id":112537,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":null,
                "skus":null,
                "sonList":null
                },
                {
                "name":"YF-ARC-VS1B",
                "img":"图片18.png",
                "id":112538,
                "url":"",
                "webUrl":null,
                "pId":null,
                "sort":1,
                "keyWords":[
                ],
                "describe":null,
                "skus":null,
                "sonList":null
                },
        ],
        "img":"",
        "seoTitle":null,
        "seoKeyWords":null,
        "seoDescription":null,
        "pid":135
        }
        ],
        "shopList":[
        ],
        "img":"",
        "seoTitle":null,
        "seoKeyWords":null,
        "seoDescription":null,
        "pid":0
    },
        
    // {
    // "id":1247,
    // "catName":"Car Plate License Recognition System ",
    // "catUrl":"/Car-Plate-License-Recognition-System--1631239802847.html",
    // "webUrl":"",
    // "sort":0,
    // "catList":[
    // {
    // "id":1251,
    // "catName":"YF-ARC Series",
    // "catUrl":"/YF-ARC-Series-1631241438112.html",
    // "webUrl":"",
    // "sort":0,
    // "catList":[
    // ],
    // "shopList":[
    // {
    // "name":" Plate License Recognition System YF-ARC-C02",
    // "img":"16_dc06478721034ffa83171ab3db0d8459.png",
    // "id":3106,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":1,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"Plate License Recognition System YF-ARC-P001",
    // "img":"16_a7eeb3cc5b0f4a7ca4b9f1fd63affc00.png",
    // "id":3108,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"Plate License Recognition System YF-ARC-P002",
    // "img":"16_cf962c90a2b648a5934e958cc6c8665e.png",
    // "id":3109,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"Plate License Recognition System YF-ARC-P003",
    // "img":"16_ec4bd9ce005c4ffb98351104c98ba059.png",
    // "id":3110,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":" Plate License Recognition System YF-ARC-S01",
    // "img":"16_67edda709edd4e649da370332b14b30f.png",
    // "id":3459,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":" Plate License Recognition System YF-ARC-S02",
    // "img":"16_5abd576c39ab48dc8c5ecf43a306879f.png",
    // "id":3460,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // }
    // ],
    // "img":"",
    // "seoTitle":null,
    // "seoKeyWords":null,
    // "seoDescription":null,
    // "pid":1247
    // }
    // ],
    // "shopList":[
    // ],
    // "img":"",
    // "seoTitle":null,
    // "seoKeyWords":null,
    // "seoDescription":null,
    // "pid":0
    // },
    {
    "id":122,
    "catName":"智能闸",
    "catUrl":"/Turnstile-Gate-1611639646052.html",
    "webUrl":"",
    "sort":1,
    "catList":[
    {
    "id":123,
    "catName":"YF-MAR Series",
    "catUrl":"/YF-MAR-Series-1611639712418.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-MAR-B01",
    "img":"16_8c1615ed5c46473fa0bad0f5f8d8b132.png",
    "id":287,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 70kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B02",
    "img":"16_8c1615ed5c46473fa0bad0f5f8d8b132.png",
    "id":292,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B05",
    "img":"16_b182a45523314d65aaa675d05292c44c.png",
    "id":294,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B06",
    "img":"16_b182a45523314d65aaa675d05292c44c.png",
    "id":295,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B03",
    "img":"16_a852727abb074553bf3c1da1aa8072cb.png",
    "id":296,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 70kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B04",
    "img":"16_a852727abb074553bf3c1da1aa8072cb.png",
    "id":297,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B11",
    "img":"16_fa763ad654d44a098eafc5c3c013258c.png",
    "id":298,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 70kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B12",
    "img":"16_fa763ad654d44a098eafc5c3c013258c.png",
    "id":299,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. A 1200 line magnetic angle encoder is designed in the movement, which makes the position of the gate wing accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. It adopts industrial 32-bit ARM chip design, with multi-channel (I / O) I / O interface and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B21",
    "img":"16_12bdce83679b493c9d1670e6ba9f333c.png",
    "id":300,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 70kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MAR-B22",
    "img":"16_12bdce83679b493c9d1670e6ba9f333c.png",
    "id":301,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: brushless motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":122
    },
    {
    "id":124,
    "catName":"YF-VEN Series",
    "catUrl":"/YF-VEN-Series-1611639751074.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-VEN-S01",
    "img":"16_8a641113602347369eb5d1c7cd749551.png",
    "id":302,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":null,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-VEN-B01",
    "img":"16_8796c01cb2b84244a926cac99cf96022.png",
    "id":303,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 280 * 980mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 950mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 60W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 50kg</p>`,
    "features":`<p>1. Stainless steel wire drawing 304;;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover and 1.2mm for the body;;</p>
    <p>3. Laser welding process, fine grinding process;;</p>
    <p>4. Infrared anti pinch protection;;</p>
    <p>5. Swipe the card to open the brake and reverse the alarm;;</p>
    <p>6. Breaking into the infrared alarm illegally;;</p>
    <p>7. The service life is more than 5 million times;";</p>`,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-VEN-B02",
    "img":"16_8796c01cb2b84244a926cac99cf96022.png",
    "id":304,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 280 * 980mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 950mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 60W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 65kg"</p>`,
    "features":`<p>1. Stainless steel wire drawing 304;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover and 1.2mm for the body;</p>
    <p>3. Laser welding process, fine grinding process;</p>
    <p>4. Infrared anti pinch protection;</p>
    <p>5. Swipe the card to open the brake and reverse the alarm;</p>
    <p>6. Breaking into the infrared alarm illegally;</p>
    <p>7. The service life is more than 5 million times;"</p>`,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-VEN-Y01",
    "img":"16_74caead573f74b7e9ca78fc51425b5c4.png",
    "id":305,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 280 * 980mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 570mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 55kg</p>`,
    "features":`<p>1. Stainless steel wire drawing 304;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover and 1.2mm for the body;</p>
    <p>3. Laser welding process, fine grinding process;</p>
    <p>4. Infrared anti pinch protection;</p>
    <p>5. Swipe the card to open the brake and reverse the alarm;</p>
    <p>6. Breaking into the infrared alarm illegally;</p>
    <p>7. The movement is equipped with mechanical anti pinch device, which can be used in case of infrared failure;</p>
    <p>8. The service life is more than 5 million times;"</p>`,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-VEN-Y02",
    "img":"16_74caead573f74b7e9ca78fc51425b5c4.png",
    "id":384,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 280 * 980mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>Width: ≤ 570mm, channel width: 5704;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p><p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double core 75kg"</p>
    `,
    "features":`<p>1.Stainless steel wire drawing;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover and 1.2mm for the body;</p>
    <p>3. Laser welding process, fine grinding process;</p>
    <p>4. Infrared anti pinch protection;</p>
    <p>5. Swipe the card to open the brake and reverse the alarm;</p>
    <p>6. Breaking into the infrared alarm illegally;</p>
    <p>7. The movement is equipped with mechanical anti pinch device, which can be used in case of infrared failure;</p>
    <p>8. The service life is more than 5 million times;"</p>
    `,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":122
    },
    {
    "id":125,
    "catName":"YF-JUP Series",
    "catUrl":"/YF-JUP-Series-1611640727898.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-JUP-B01",
    "img":"16_025564c66b3643dda2ab465e417de5ad.png",
    "id":323,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 70kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-B02",
    "img":"16_025564c66b3643dda2ab465e417de5ad.png",
    "id":326,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-B11",
    "img":"16_2f76ab6f78e7464abc8e8d3512ed5950.png",
    "id":327,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 70kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-B12",
    "img":"16_2f76ab6f78e7464abc8e8d3512ed5950.png",
    "id":328,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-T01",
    "img":"16_4052879050c34ccf9cb9f8101fdc7438.png",
    "id":329,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 70kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-T02",
    "img":"16_4052879050c34ccf9cb9f8101fdc7438.png",
    "id":330,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":` <p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-Z01",
    "img":"16_c63e627d0bec46c1ab16dccba4b63cbc.png",
    "id":331,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: SINGLE CORE 70KGS"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-Z02",
    "img":"16_c63e627d0bec46c1ab16dccba4b63cbc.png",
    "id":332,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 180 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-C01",
    "img":"16_c6212caa891043acad1810f5b6e98844.png",
    "id":333,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 150 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: SINGLE CORE 70KG"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-JUP-C02",
    "img":"16_c6212caa891043acad1810f5b6e98844.png",
    "id":334,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 150 * 965mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 1000mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1. Material: Φ 304 drawing stainless steel</p>
    <p>2. Thickness: non standard top cover 2.0 mm, fuselage foot 1.5 mm</p>
    <p>3. Technology: laser cutting of box body;</p>
    <p>4. Motor: domestic servo motor</p>
    <p>5. Functional features of the movement: the core is designed with 1200 line magnetic angle encoder, which makes the gate wing positioning accurate during operation; the system detects the rotation of the gate wing at each position and state in real time;</p>
    <p>6. The movement is designed with high-power electronic clutch brake to prevent illegal personnel from entering and damaging the movement;</p>
    <p>7. Design features of the control board: industrial grade 32-bit ARM chip design, with multi-channel (I / O) input and output interface, and unidirectional bidirectional counting output;</p>
    <p>8. Communication interface: RS232 or RS485 optional</p>
    <p>9. Infrared logic: standard 6 pairs of infrared, which can be extended to 16 pairs; with anti tailing and anti submarine functions, it can judge single pedestrian or single pedestrian + trunk</p>
    <p>10. Access mode: normally open, barrier free, normally closed standard, and authorization mode is optional.</p>
    <p>11. Fire fighting mode: input the fire signal and the door wing will open automatically."</p>
    `,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":122
    },
    {
    "id":126,
    "catName":"YF-MER Series",
    "catUrl":"/YF-MER-Series-1611640754426.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-MER-B02",
    "img":"16_fd861752748d4f9088db3579c061b75f.png",
    "id":337,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":null,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MER-Y01",
    "img":"16_b8daa1f3c016425ba6dd0714990b36c8.png",
    "id":339,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":null,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MER-Y02",
    "img":"16_b8daa1f3c016425ba6dd0714990b36c8.png",
    "id":340,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":null,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MER-B01",
    "img":"16_fd861752748d4f9088db3579c061b75f.png",
    "id":385,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe": `<p>1. Size: 1400 * 280 * 980mm;</p>
                <p>2. Unlocking time: 0.2S;</p>
                <p>3. Traffic speed: ≤ 35 person / min;</p>
                <p>4. Channel width: ≤ 950mm;</p>
                <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
                <p>6. Driving voltage: DC24 V;</p>
                <p>7. Ambient temperature: - 30 ° to 70 °;</p>
                <p>8. Maximum power: 60W;</p>
                <p>9. Opening signal input: dry contact;</p>
                <p>10. Net weight: single core 50kg"</p>`,
    "features":`<p>1. Stainless steel wire drawing 304;</p>
                <p>2. The case thickness is non-standard 1.5mm for the top cover and 1.2mm for the body;</p>
                <p>3. Laser welding process, fine grinding process;</p>
                <p>4. Automatic rod dropping after power failure (automatic movement is powered on, and the rod is automatically put on);</p>
                <p>5. Adjustable shock absorption buffer mechanism is designed;</p>
                <p>6. The service life is more than 5 million times"</p>`,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-MER-S01",
    "img":"16_d011b247c83d4dda8148d929cc8a1b12.png",
    "id":386,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":null,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":122
    },
    {
    "id":127,
    "catName":"YF-URA Series",
    "catUrl":"/YF-URA-Series-1611641280785.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-URA-BXZ",
    "img":"16_eab387b65ad343088e7d3de361443f92.png",
    "id":306,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. #304 brushed stainless steel.</p>
    <p>2. The thickness of the chassis, the top cover is non-standard 1.5mm, and the body is non-standard 1.2mm. The center shaft is 3.0mm.</p>
    <p>3. Fine welding process and fine grinding process.</p>
    <p>4. Swipe the card to open the gate and reverse the alarm.</p>
    <p>5. The service life is more than 5 million times."</p>
    `,
    "features":`<p>1. Mechanical anti tailing design, effectively realize only one person at a time</p>
    <p>2. Mechanical electronic control locking mechanism to prevent illegal collision and reverse passage</p>
    <p>3. Closed block structure, security level is very high</p>
    <p>4. Channel width: 550mm</p>
    <p>5. Material: 304</p>
    <p>6. Input interface: dry contact relay signal, 12V level or 12V pulse signal with pulse width ≥ 100ms"</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-URA-Q01",
    "img":"16_0770979e1c0a4480a07a55fec3739b05.png",
    "id":341,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Single channel size: 1520 * 1480 * 2250mm,Dual channel size: 2200 * 1480 * 2250mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 620mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 250kg, double movement 400kg"</p>
    `,
    "features":`<p>1. Stainless steel wire drawing 304;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover, 1.2mm for the body, and 3.0mm for the central shaft</p>
    <p>3.Fine grinding technology; </p>
    <p>4. Swipe the card to open the switch and reverse the alarm;</p>
    <p>5. The service life is more than 5 million times;</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-URA-Q02",
    "img":"16_52c059a907b840f8abb0473d023dd93e.png",
    "id":342,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Single channel size: 1520 * 1480 * 2250mm,Dual channel size: 2200 * 1480 * 2250mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 620mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 250kg, double movement 400kg</p>
    `,
    "features":`<p>1. Stainless steel wire drawing 304;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover, 1.2mm for the body, and 3.0mm for the central shaft</p>
    <p>3. Fine grinding technology;</p>
    <p>4. Swipe the card to open the switch and reverse the alarm;</p>
    <p>5. The service life is more than 5 million times;</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-URA-Q11",
    "img":"16_ef7b7abffe664028ad643ff9775f09e8.png",
    "id":343,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Single channel size: 1520 * 1280 * 2250mm,Dual channel size: 2200 * 1280 * 2250mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 620mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>0. Net weight: single core 220kg, double core 370kg</p>
    `,
    "features":`<p>1. Stainless steel wire drawing 304;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover, 1.2mm for the body, and 3.0mm for the central shaft</p>
    <p>3. Fine grinding technology;</p> 
    <p>4. Swipe the card to open the switch and reverse the alarm;</p>
    <p>5. The service life is more than 5 million times;"</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-URA-Q12",
    "img":"16_eabde3d08c18466da89425cdc262caf3.png",
    "id":344,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Single channel size: 1520 * 1280 * 2250mm,Dual channel size: 2200 * 1280 * 2250mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Channel width: ≤ 620mm;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 220kg, double core 370kg"</p>
    `,
    "features":`<p>1. Stainless steel wire drawing 304;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover, 1.2mm for the body, and 3.0mm for the central shaft</p>
    <p>3. Fine grinding technology;</p>
    <p>4. Swipe the card to open the switch and reverse the alarm;</p>
    <p>5. The service life is more than 5 million times;"</p>
    `,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":122
    },
    {
    "id":128,
    "catName":"YF-SAT Series",
    "catUrl":"/YF-SAT-Series-1611641334585.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-SAT-G01",
    "img":"16_502a95b8073f460ea195ea2bc87ffb70.png",
    "id":310,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 320 * 980mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4.Width: ≤ 570mm, channel width: 5704;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: single core 70kg"</p>
    `,
    "features":`<p>1.Stainless steel wire drawing;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover and 1.2mm for the body;</p>
    <p>3. Laser welding process, fine grinding process;</p>
    <p>4. Infrared anti pinch protection;</p>
    <p>5. Swipe the card to open the brake and reverse the alarm;</p>
    <p>6. Breaking into the infrared alarm illegally;</p>
    <p>7. The service life is more than 5 million times;"</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-SAT-G02",
    "img":"16_502a95b8073f460ea195ea2bc87ffb70.png",
    "id":311,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1400 * 320 * 980mm;</p>
    <p>2. Unlocking time: 0.2S;</p>
    <p>3. Traffic speed: ≤ 35 person / min;</p>
    <p>4. Width: ≤ 570mm, channel width: 5704;</p>
    <p>5. Input voltage: ac110 / 220V ± 10%, 50 / 60Hz;</p>
    <p>6. Driving voltage: DC24 V;</p>
    <p>7. Ambient temperature: - 30 ° to 70 °;</p>
    <p>8. Maximum power: 200W;</p>
    <p>9. Opening signal input: dry contact;</p>
    <p>10. Net weight: double movement 90kg"</p>
    `,
    "features":`<p>1.Stainless steel wire drawing;</p>
    <p>2. The case thickness is non-standard 1.5mm for the top cover and 1.2mm for the body;</p>
    <p>3. Laser welding process, fine grinding process;</p>
    <p>4. Infrared anti pinch protection;</p>
    <p>5. Swipe the card to open the brake and reverse the alarm;</p>
    <p>6. Breaking into the infrared alarm illegally;</p>
    <p>7. The service life is more than 5 million times;"</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-SAT-Y01",
    "img":"16_61aef20c059044449c1f5cf72b4d8228.png",
    "id":319,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1410 * 340 * 1050mm</p>
    <p>2. Unlocking time: 0.2S</p>
    <p>3. Traffic speed: ≤ 35 people / min</p>
    <p>4. Channel width: 550mm</p>
    <p>5. Voltage input: 100-240V</p>
    <p>6. Motor voltage: 24V</p>
    <p>7. Ambient temperature: - 25 ℃ - + 70 ℃</p>
    <p>8. Power: 120W</p>
    <p>9. Opening signal input: dry contact, 12V level</p>
    <p>10. Signal or pulse width > 100ms</p>
    <p>11. Communication access: RS485</p>
    `,
    "features":`<p>1. Single core, 304 stainless steel</p>
    <p>2. Laser cutting of box</p>
    <p>3. Powerful and fine grinding process</p>
    <p>4. Surface drawing</p>
    <p>5. Infrared anti pinch protection</p>
    <p>6. Breaking into infrared alarm illegally</p>
    <p>7. Swipe the card to open the reverse reverse alarm"</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-SAT-Y02",
    "img":"16_61aef20c059044449c1f5cf72b4d8228.png",
    "id":320,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Size: 1410 * 340 * 1050mm</p>
    <p>2. Unlocking time: 0.2S</p>
    <p>3. Traffic speed: ≤ 35 people / min</p>
    <p>4. Channel width: 550mm</p>
    <p>5. Voltage input: 100-240V</p>
    <p>6. Motor voltage: 24V</p>
    <p>7. Ambient temperature: - 25 ℃ - + 70 ℃</p>
    <p>8. Power: 120W</p>
    <p>9. Opening signal input: dry contact, 12V level</p>
    <p>10. Signal or pulse width > 100ms</p>
    <p>11. Communication access: RS485"</p>
    `,
    "features":`<p>1. Dual movement, 304 stainless steel</p>
    <p>2. Laser cutting of box</p>
    <p>3. Powerful and fine grinding process</p>
    <p>4. Surface drawing</p>
    <p>5. Infrared anti pinch protection</p>
    <p>6. Breaking into infrared alarm illegally</p>
    <p>7. Swipe the card to open the reverse reverse alarm"</p>
    `,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":122
    },
    {
    "id":131,
    "catName":"YF-NEP Series",
    "catUrl":"/YF-NEP-Series-1611804907699.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-NEP-R01",
    "img":"16_24d10e9ce26c4a41a4d6371ca76e7430.png",
    "id":382,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Processor: dual core processor + 1G memory + 16g EMMC</p>
    <p>2. Operating system: Embedded Linux operating system</p>
    <p>3. Storage: support TF card storage</p>
    <p>4. Angle of view: vertical angle: 30 degrees; horizontal angle: 30 degrees</p>
    <p>5. Imaging device: 1 / 2.8 ""progressive scan CMOS</p>
    <p>6: Lens: 6mm</p>
    <p>7. Temperature measurement accuracy: ± 0.3 ℃</p>
    <p>8. Temperature resolution: 0.1 ℃</p>
    <p>9. Temperature measurement distance: ≤ 30cm</p>
    <p>10. Response time: 300ms"</p>
    `,
    "features":`<p>1. Support binocular living detection</p>
    <p>2. Support human movement face tracking exposure in strong backlight environment</p>
    <p>3. Unique face recognition algorithm, accurate face recognition, face recognition time is less than 0.5s</p>
    <p>4. Integrated CPU</p>
    <p>5. H.265 video stream is directly connected to NVR and other storage devices through onvif protocol and gb28181 protocol</p>
    <p>6. Support local storage of TF card, continuous storage of pictures for 1 year, continuous storage of video for 1 month or longer (related to the capacity of optional TF Card)</p>
    <p>7. MTBF of main engine is more than 50000h</p>
    <p>8. Support temperature measurement in medium distance and high temperature alarm</p>
    <p>9. Support temperature data interface protocol docking</p>
    <p>10. Support 24000 + face comparison database and 160000 recognition records</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-NEP-R02",
    "img":"16_329d97473dff43ff870c2c5a0e622e79.png",
    "id":383,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Processor: dual core processor + 1G memory + 16g EMMC</p>
    <p>2. Operating system: Embedded Linux operating system</p>
    <p>3. Storage: support TF card storage</p>
    <p>4. Angle of view: vertical angle: 30 degrees; horizontal angle: 30 degrees</p>
    <p>5. Imaging device: 1 / 2.8 ""progressive scan CMOS</p>
    <p>6: Lens: 6mm</p>
    `,
    "features":`<p>1. Support binocular living detection</p>
    <p>2. Support human movement face tracking exposure in strong backlight environment</p>
    <p>3. Unique face recognition algorithm, accurate face recognition, face recognition time is less than 0.5s</p>
    <p>4. Built in CPU</p>
    <p>5. H.265 video stream is directly connected to NVR and other storage devices through onvif protocol and gb28181 protocol</p>
    <p>6. Support local storage of TF card, continuous storage of pictures for 1 year, continuous storage of video for 1 month or longer (related to the capacity of optional TF Card)</p>
    <p>7. MTBF of main engine is more than 50000h</p>
    <p>8. Support 24000 + face comparison database and 160000 recognition records</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-NEP-F01",
    "img":"16_ec653dca580d4dce8e6bd4d7347c584f.png",
    "id":387,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. USB interface</p>
    <p>2. Working frequency: 125 kHz</p>
    <p>3. Card reading distance: 5-8cm</p>
    <p>4. Ten digit decimal card number</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-NEP-D01",
    "img":"16_b43fc2bf59f74882b77fbac5f6363eb7.png",
    "id":388,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Wiengand34 card reading distance: ≥ 5cm</p>
    <p>2. Built in buzzer</p>
    <p>3. Ten digit decimal card number"</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-NEP-D01",
    "img":"16_375909d958f34124a5f50207a8d43175.png",
    "id":389,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Wiengand34 card reading distance: ≥ 5cm</p>
    <p>2. Built in buzzer</p>
    <p>3. Ten digit decimal card number"</p>
    `,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":122
    }
    ],
    "shopList":[
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":0
    },
    // {
    // "id":132,
    // "catName":"Parking Guidance",
    // "catUrl":"/Parking-Guidance-1611805461135.html",
    // "webUrl":"",
    // "sort":1,
    // "catList":[
    // {
    // "id":133,
    // "catName":"YF-PLA",
    // "catUrl":"/YF-PLA-1611805494347.html",
    // "webUrl":"",
    // "sort":0,
    // "catList":[
    // ],
    // "shopList":[
    // {
    // "name":"YF-PLA-S01",
    // "img":"16_245781b550b6480a9b45bba767bdfb19.png",
    // "id":347,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>2 megapixel, with full color LED lamp in parking space, with two network ports</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-S02",
    // "img":"16_95f9847adde045c490def1c10f19dc96.png",
    // "id":348,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-C01",
    // "img":"16_6396be65e5e24965b2cbf7c16facef7b.png",
    // "id":350,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-C02",
    // "img":"16_b06c52a1d0aa4017acd74b5307974fbf.png",
    // "id":351,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-X01",
    // "img":"16_9470f9a0656644e0bac8e038598efb22.png",
    // "id":353,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. When the parking space is less than 10, the number is displayed in red, and the number greater than 10 is shown in green</p>
    // <p>2. Communication mode: RS485 @ 9600bps</p>
    // <p>3. Communication distance: ≤ 300m</p>
    // <p>4. Display size: 608 * 152mm</p>
    // <p>5. Appearance dimension: 1065 * 270 * 90</p>
    // <p>6. Working temperature: - 20 ℃ ~ + 65 ℃"</p>
    // `,
    // "feeatures":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. Order the number of screens according to the actual CAD plan, customers can choose the number of guide screens freely!</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-X02",
    // "img":"16_51e4ba87b8794b979660e84d2fc4dd88.png",
    // "id":354,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. When the parking space is less than 10, the number is displayed in red, and the number greater than 10 is shown in green</p>
    // <p>2. Communication mode: RS485 @ 9600bps</p>
    // <p>3. Communication distance: ≤ 300m</p>
    // <p>4. Display size: 912 * 152mm</p>
    // <p>5. Appearance dimension: 1370 * 90 * 270mm</p>
    // <p>6. Working temperature: - 20 ℃ ~ + 65 ℃</p>
    // `,
    // "features":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. Order the number of screens according to the actual CAD plan</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-X03",
    // "img":"16_b18c595b7f6a425d9b3361dc5c5ba4dc.png",
    // "id":355,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. When the parking space is less than 10, the number is displayed in red, and the number greater than 10 is shown in green</p>
    // <p>2. Communication mode: RS485 @ 9600bps</p>
    // <p>3. Communication distance: ≤ 300m</p>
    // <p>4. Appearance dimension: 1680 * 90 * 270mm</p>
    // <p>5. Working temperature: - 20 ℃ ~ + 65 ℃"</p>
    // `,
    // "features":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. The number of screens ordered based on the actual CAD plan</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-X04",
    // "img":"16_198b6e1e5ff44250b02f48f2ae79dd55.png",
    // "id":356,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. When the parking space is less than 10, the number is displayed in red, and the number greater than 10 is shown in green</p>
    // <p>2. Communication mode: RS485 @ 9600bps</p>
    // <p>3. Communication distance: ≤ 300m</p>
    // <p>4. Display size: 608 * 152mm</p>
    // <p>5. Appearance dimension: 700 * 200 * 90</p>
    // <p>6. Working temperature: - 20 ℃ ~ + 65 ℃"</p>
    // `,
    // "feeature":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. The number of screens ordered based on the actual CAD plan"</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-X05",
    // "img":"16_c8a7e55a24284e819ff6700669522007.png",
    // "id":357,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. Communication mode: RS485 @ 9600bps</p>
    // <p>2. Communication distance: ≤ 300m</p>
    // <p>3. Display module: Red / Green monochrome P10</p>
    // <p>4. Appearance dimension: 2200 * 750 * 200 mm</p>
    // <p>5. Working temperature: - 20 ℃ ~ + 65 ℃"</p>
    // `,
    // "features":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. The number of screens ordered based on the actual CAD plan</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-PLA-C03",
    // "img":"16_446d5d08fd5b4fae99e7cb10ea093772.png",
    // "id":360,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. Working voltage: AC 220 V, 50 Hz</p>
    // <p>2. Communication mode: TCP / IP</p>
    // <p>3. Display system: 21.5 inch LCD</p>
    // <p>4. Input device: capacitive touch screen, transmittance: above 92%</p>
    // <p>5. Cabinet configuration: centralized power control system, multimedia power amplifier system</p>
    // <p>6. Body material: luxury surface, imported metal car paint, metal smooth finish, rust proof, antimagnetic, antistatic. Imported cold rolled steel sheet</p>
    // <p>7. Working temperature: - 10 ℃ ~ + 65 ℃</p>
    // <p> 8. Working humidity: < 80%, no condensation"</p>
    // `,
    // "skus":null,
    // "sonList":null
    // }
    // ],
    // "img":"",
    // "seoTitle":null,
    // "seoKeyWords":null,
    // "seoDescription":null,
    // "pid":132
    // },
    // {
    // "id":134,
    // "catName":"YF-STAR",
    // "catUrl":"/YF-STAR-1611805506545.html",
    // "webUrl":"",
    // "sort":0,
    // "catList":[
    // ],
    // "shopList":[
    // {
    // "name":"YF-STAR-T01",
    // "img":"16_b425d85e5331487fbcd66ada700bf905.png",
    // "id":361,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. Working voltage: 12 ~ 28V (rated 24 V)</p>
    // <p>2. Shell material: ABS engineering plastic</p>
    // <p>3. Overall dimension: 118h * 120mm</p>
    // <p>4. Working temperature: - 20 ℃ - 60 ℃</p>
    // <p>5. Color indication: Red / Green / blue (8 three color LEDs)</p>
    // <p>6. Communication mode: RS485@9600bps</p>
    // <p>7. Installation height: 1.8 ~ 3.0m (2.5m recommended)</p>
    // <p>8. Horizontal distance: within 4.5 m ahead of wheel positioner"</p>
    // `,
    // "features":`<p>1. Integrated parking detector and indicator</p>
    // <p>2. Led adopts super bright three color lamp beads, which can indicate 7 colors</p>
    // <p>3. Built in infrared receiver</p>
    // <p>4. Adopt short circuit, reverse connection and wrong connection protection design</p>
    // <p>5. The connection port is connected with plug-in terminal</p>
    // <p>6. Matching terminal board"</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-STAR-K01",
    // "img":"16_635df9f4e5614c75b5106120851a4388.png",
    // "id":362,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. Working voltage: AC220V</p>
    // <p>2. Overall dimension: 380 × 300 × 150 mm</p>
    // <p>3. Communication mode: 1-way can @ 20kbps</p>
    // <p>4-way RS485 @ 9600bps</p>
    // <p>4. Communication distance: can: ≤ 1000m (RVSP 0.75 * 2)</p>
    // <p>5. Ethernet: 100m (CAT5 cable)</p>
    // <p>6. Capacity: 62 nodes</p>
    // `,
    // "features":`<p>1. The node controller is used to connect the central controller, parking detector, LED display, etc</p>
    // <p>2. Adopt RS485 and can bus hybrid communication mechanism</p>
    // <p>3. The imported 32-bit ARM processor is adopted</p>
    // <p>4. Can bus industrial communication interface and four RS485 communication interface are adopted</p>
    // <p>5. The equipment has the protection design of short circuit, reverse connection and wrong connection</p>
    // <p>6. The power supply has the functions of short circuit, overload and over-voltage protection"</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-STAR-K02",
    // "img":"16_2d5b12f69f104fd59a1c30e05f3054d2.png",
    // "id":363,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. Working voltage: AC220V</p>
    // <p>2. Overall dimension: 380 × 300 × 150 mm</p>
    // <p>3. Communication mode: 1-way can @ 20kbps</p>
    // <p>One channel 10 / 100BaseT Ethernet</p>
    // <p>4. Communication distance: can: ≤ 1000M</p>
    // <p>5. Ethernet: 100M</p>
    // <p>6. Capacity: up to 62 node controllers</p>
    // `,
    // "features":`<p>1. Ethernet communication is used between central controller and upper computer</p>
    // <p>2. Adopt RS485 and can bus hybrid communication mechanism</p>
    // <p>3. The imported 32-bit ARM processor is adopted</p>
    // <p>4. The equipment has the protection design of short circuit, reverse connection and wrong connection</p>
    // <p>5. The power supply has the function of short circuit, overload and over-voltage protection</p>
    // <p>6. The communication bus adopts advanced anti-collision, fault-tolerant and troubleshooting algorithm mechanism</p>
    // <p>7. After the associated information is downloaded, the associated information will be automatically saved and run independently and correctly without the computer</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-STAR-X01",
    // "img":"16_dee91cbb80cd48cdbf0e5b1432099472.png",
    // "id":365,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. When the parking space is less than 10, the number is displayed in red, and the number greater than 10 is shown in green</p>
    // <p>2. Communication mode: RS485 @ 9600bps</p>
    // <p>3. Communication distance: ≤ 300m</p>
    // <p>4. Display size: 608 * 152mm</p>
    // <p>5. Appearance dimension: 1065 * 270 * 90</p>
    // <p>6. Working temperature: - 20 ℃ ~ + 65 ℃</p>
    // `,
    // "features":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. The number of screens ordered based on the actual CAD plan</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-STAR-X02",
    // "img":"16_fc5fe40fd8ea40bca4c78026d18518c5.png",
    // "id":366,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. When the parking space is less than 10, the number is displayed in red, and the number greater than 10 is shown in green</p>
    // <p>2. Communication mode: RS485 @ 9600bps</p>
    // <p>3. Communication distance: ≤ 300m</p>
    // <p>4. Display size: 912 * 152mm</p>
    // <p>5. Appearance dimension: 1370 * 90 * 270mm</p>
    // <p>6. Working temperature: - 20 ℃ ~ + 65 ℃"</p>
    // `,
    // "features":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. The number of screens ordered based on the actual CAD plan</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-STAR-X03",
    // "img":"16_38756f470058445392f0a580ce729d09.png",
    // "id":368,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. When the parking space is less than 10, the number is displayed in red, and the number greater than 10 is shown in green</p>
    // <p>2. Communication mode: RS485 @ 9600bps</p>
    // <p>3. Communication distance: ≤ 300m</p>
    // <p>4. Appearance dimension: 1680 * 90 * 270mm</p>
    // <p>5. Working temperature: - 20 ℃ ~ + 65 ℃</p>
    // `,
    // "features":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. The number of screens ordered based on the actual CAD plan</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-STAR-X04",
    // "img":"16_91fbd0efb0de48a3a87ed10b1f8adae8.png",
    // "id":371,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. When the parking space is less than 10, the number is displayed in red, and the number greater than 10 is shown in green</p>
    // <p>2. Communication mode: RS485 @ 9600bps</p>
    // <p>3. Communication distance: ≤ 300m</p>
    // <p>4. Display size: 608 * 152mm</p>
    // <p>5. Appearance dimension: 700 * 200 * 90</p>
    // <p>6. Working temperature: - 20 ℃ ~ + 65 ℃"</p>
    // `,
    // "features":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. The number of screens ordered based on the actual CAD plan,</p>
    // `,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-STAR-X05",
    // "img":"16_630b766bb7f8428c9d672c0c19bd6d36.png",
    // "id":372,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":`<p>1. Communication mode: RS485 @ 9600bps</p>
    // <p>2. Communication distance: ≤ 300m</p>
    // <p>3. Display module: Red / Green monochrome P10</p>
    // <p>4. Appearance dimension: 2200 * 750 * 200 mm</p>
    // <p>5. Working temperature: - 20 ℃ ~ + 65 ℃"</p>
    // `,
    // "features":`<p>1. Dust proof design, the shell uses special paint, not easy to change color;</p>
    // <p>2. The red and green indication is clear and distinguishable;</p>
    // <p>3.5.0 acrylic panel, shell cold steel baking paint;</p>
    // <p>4. Low power design with short circuit, overload, over-current and over-voltage protection;</p>
    // <p>5. Industrial design and strict static, lightning, surge and group pulse tests are adopted to effectively ensure the reliable use of the equipment;</p>
    // <p>6. The luminous intensity of the lamp bead reaches 1600cd, the visible distance is more than 50m, and the visual angle is wide;</p>
    // <p>7. Multi direction display content support to meet the needs of various intersections.</p>
    // <p>8. Order the number of screens according to the actual CAD plan</p>
    // `,
    // "skus":null,
    // "sonList":null
    // }
    // ],
    // "img":"",
    // "seoTitle":null,
    // "seoKeyWords":null,
    // "seoDescription":null,
    // "pid":132
    // }
    // ],
    // "shopList":[
    // ],
    // "img":"",
    // "seoTitle":null,
    // "seoKeyWords":null,
    // "seoDescription":null,
    // "pid":0
    // },
    {
    "id":135,
    "catName":"升降柱",
    "catUrl":"/Bollard-Barrier-1611805551674.html",
    "webUrl":"",
    "sort":1,
    "catList":[
    {
    "id":136,
    "catName":"YF-ROC",
    "catUrl":"/YF-ROC-1611805574889.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-ROC-S01",
    "img":"16_6b7a84a1fd344fe2a6ee24f7f4f2f7cd.png",
    "id":373,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":1,
    "keyWords":[
    ],
    "describe":`<p>1. Design of electro-hydraulic fully sealed motor</p>
    <p>2. Frequency of use: continuous rise and fall every 13 seconds</p>
    <p>3. Power supply: AC220V</p>
    <p>4. Working temperature: - 30 ~ + 50</p>
    <p>5. Power: 370W</p>
    <p>6. Protection level: IP68, normal operation when immersed in water and sediment</p>
    <p>7. Rising speed: 150 mm / S (stroke: 600 mm, lifting time: 4S)</p>
    <p>8. Descending speed: 250mm / S (stroke: 600mm, falling time: 2.2s)</p>
    <p>9. Column diameter: 219mm (nonstandard fabrication allowed)</p>
    <p>10. Stroke height: 600mm</p>
    <p>11. Column wall thickness: 6 mm (non-standard production is allowed)</p>
    <p>12. Operation noise: < 80dB</p>
    `,
    "features":`<p>1. 304 or above stainless steel material is used for galvanizing and plastic spraying, and the anticorrosion period is more than 20 years</p>
    <p>2. During maintenance and repair, each accessory can be organized and disassembled by screws without damaging the embedded foundation</p>
    <p>3. Assembly structure, embedded barrel can be used permanently</p>
    <p>4. In case of power failure or failure, if the lifting column is in the rising state and needs to be lowered, the raised column can be lowered to the level with the ground through manual operation, so as to let the vehicle pass normally.</p>
    <p>5. Using 3M diamond grade reflective film, the reflective rate can reach more than 85%</p>
    <p>6. Remote control device, through wireless remote control, can lift and drop the barrier pillar within 30 meters around the controller</p>
    <p>7. Radar monitoring function is selected to protect the safety of passing vehicles and pedestrians during the lifting of the lifting column</p>
    <p>8. It can be connected with the Internet of things, safe city, intelligent parking management system and other intelligent control systems</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-ROC-S02",
    "img":"16_6b7a84a1fd344fe2a6ee24f7f4f2f7cd.png",
    "id":374,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":1,
    "keyWords":[
    ],
    "describe":null,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-ROC-S03",
    "img":"16_6b7a84a1fd344fe2a6ee24f7f4f2f7cd.png",
    "id":375,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":1,
    "keyWords":[
    ],
    "describe":`<p>1. Design of electro-hydraulic fully sealed motor</p>
    <p>2. Frequency of use: continuous rise and fall every 13 seconds</p>
    <p>3. Power supply: DC36V</p>
    <p>4. Working temperature: - 30 ~ + 50</p>
    <p>5. Power: 370W</p>
    <p>6. Protection level: IP68, normal operation when immersed in water and sediment</p>
    <p>7. Rising speed: 150 mm / S (stroke: 600 mm, lifting time: 4S)</p>
    <p>8. Descending speed: 250mm / S (stroke: 600mm, falling time: 2.2s)</p>
    <p>9. Column diameter: 219mm (nonstandard fabrication allowed)</p>
    <p>10. Stroke height: 600mm</p>
    <p>11. Column wall thickness: 6 mm (non-standard production is allowed)</p>
    <p>12. Operation noise: < 80dB</p>
    `,
    "features":`<p>1. Unique motor performance, low noise, fast and stable operation, frequent lifting and landing, suitable for a variety of places</p>
    <p>2. Agile control. The control unit adopts multi-functional logic control box, which can adjust a variety of different function modes</p>
    <p>3. Using low voltage DC motor as power unit, it is safe and reliable without worrying about leakage risk</p>
    <p>4. In case of emergency such as power failure, the column can be raised or lowered manually to open the channel and release the vehicle</p>
    <p>5. Economical, energy-saving and environmental protection, low consumption, low failure rate, long service life and low maintenance cost</p>
    <p>6. It has the function of protection against obstacles to protect the safety of people and objects</p>
    <p>7. It can be connected with the Internet of things, safe city, intelligent parking management system and other systems</p>
    <p>8.36v motor</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-ROC-S04",
    "img":"16_7dd5513b23c94d5e86d9f292a72c3701.png",
    "id":1571,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":1,
    "keyWords":[
    ],
    "describe":`<p>1. Column diameter: 219mm, customizable</p>
    <p>2. Floor height: 600mm, customizable</p>
    <p>3. Column wall thickness: 3mm, 6mm can be customized</p>
    <p>4. The thickness of the column flange is 10 mm, and the column bottom can be lengthened and reinforced</p>
    <p>5. The material is 304 high quality stainless steel</p>
    <p>6. Optional led warning light</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-ROC-S05",
    "img":"16_5ef8a96a0e98465fab774085fb2be229.png",
    "id":1572,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":1,
    "keyWords":[
    ],
    "describe":`<p>1. Column diameter: 219mm, customizable</p>
    <p>2. Floor height: 600mm, customizable</p>
    <p>3. Column wall thickness: 3mm, 6mm can be customized</p>
    <p>4. The thickness of the column flange is 10 mm, and the column bottom can be lengthened and reinforced</p>
    <p>5. The material is 304 high quality stainless steel</p>
    <p>6. Optional led warning light</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-ROC-L01",
    "img":"16_9b894731ae1149af9df29c221dcb087a.png",
    "id":377,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Lifting height: 600mm, customizable</p>
    <p>2. Embedded depth: 100 ~ 780mm, can be customized</p>
    <p>3. Blocking width: 1-6m, customizable</p>
    <p>4. Lifting time: 1s ~ 2.5s</p>
    <p>5. Falling time: 0.5s ~ 1s</p>
    <p>6. Panel thickness: 16mm / 20mm / 25mm, customizable</p>
    `,
    "features":`<p>1. It is convenient and easy to maintain, and the internal power unit can be effectively prevented</p>
    <p>2. According to the weight of passing vehicles, the thickness of steel plate is customized to protect the long-term safe use of the roadblock machine</p>
    <p>3. During maintenance and repair, each accessory can be assembled and disassembled by screws without damaging the embedded foundation</p>
    <p>4. Install super bright LED light to warn and light at night</p>
    <p>5. It can be connected with the Internet of things, safe city, intelligent parking management system and other intelligent control systems</p>
    <p>6. It has infrared, radar and ground sensing linkage functions, which can protect the safety of passing vehicles and pedestrians in the process of raising the roadblock</p>
    `,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-ROC-P01",
    "img":"16_e19f1a9a4dcb41379fbcc5db70a4605f.png",
    "id":378,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Bearing pressure: 50t</p>
    <p>2. Control system: hydraulic and electric control system</p>
    <p>3. Power supply voltage: 220 V / 380 V industrial power</p>
    <p>4. System power (W): 4.0kw</p>
    <p>5. Material: A3 steel, sprayed with antirust primer</p>
    <p>6. Thickness: 10 mm, 20 mm optional</p>
    <p>7. Equipment width: speed reduction ridge 540mm</p>
    <p>8. Equipment height: deceleration ridge type 75mm</p>
    <p>9. Blade thickness: 10 mm</p>
    <p>10. Blade lifting height: 110mm</p>
    <p>11. Lifting time: 3-4s / 600mm</p>
    <p>12. Working temperature: - 40 ℃ ~ + 60 ℃</p>
    <p>13. Protection grade: up to IP67</p>
    <p>14. Linkage: the control system has linkage function</p>
    <p>15. Storage environment: - 40 ~ 86 degrees, rain proof, moisture-proof and dust-proof</p>
    `,
    "features":`<p>1. The structure is firm and durable, the load is large, the action is fast and stable, the noise is low, and it can adapt to all kinds of working environment</p>
    <p>2. It adopts mechanical hydraulic driving mode, which is simple to install, easy to maintain, high safety performance and long service life</p>
    <p>3. According to the weight of the vehicle, the thickness is customized to protect the safe use of the tire breaker, and the lifting buffer technology ensures stable and reliable operation</p>
    <p>. It can be connected with the Internet of things, safe city, intelligent parking management system and other intelligent control systems</p>
    <p>5. The hydraulic tire breaker can be manually lowered in the power failure state without affecting the normal passage of vehicles</p>
    <p>6. It has infrared, radar and ground sensing linkage functions, which can protect the safety of passing vehicles and pedestrians during the tire breaker lifting process.</p>
    `,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":135
    }
    ],
    "shopList":[
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":0
    },
    {
    "id":188,
    "catName":"人脸识别终端",
    "catUrl":"/Face-Recognition-Terminal-Access-Control-1614909044089.html",
    "webUrl":"",
    "sort":1,
    "catList":[
    {
    "id":191,
    "catName":"YF-REN Series",
    "catUrl":"/YF-REN-Series-1614914945927.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-REN-F01",
    "img":"16_541c27df9cf74985818d829efe1a8f07.png",
    "id":644,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":null,
    "skus":null,
    "sonList":null
    },
    {
    "name":"YF-REN-F01",
    "img":"16_86594fa423a8417797d33d92ef54ccba.png",
    "id":645,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":null,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":188
    },
    {
    "id":1514,
    "catName":"YF-NEP Series",
    "catUrl":"/YF-NEP-Series-1640586544494.html",
    "webUrl":"",
    "sort":0,
    "catList":[
    ],
    "shopList":[
    {
    "name":"YF-NEP-R01",
    "img":"16_d56cf66dc08f49b89229eaedfad60a77.png",
    "id":4342,
    "url":"",
    "webUrl":null,
    "pId":null,
    "sort":0,
    "keyWords":[
    ],
    "describe":`<p>1. Processor: dual core processor + 1G memory + 16g EMMC</p>
    <p>2. Operating system: Embedded Linux operating system</p>
    <p>3. Storage: support TF card storage</p>
    <p>4. Angle of view: vertical angle: 30 degrees; horizontal angle: 30 degrees</p>
    <p>5. Imaging device: 1 / 2.8 ""progressive scan CMOS</p>
    <p>6: Lens: 6mm</p>
    <p>7. Temperature measurement accuracy: ± 0.3 ℃</p>
    <p>8. Temperature resolution: 0.1 ℃</p>
    <p>9. Temperature measurement distance: ≤ 30cm</p>
    <p>10. Response time: 300ms"</p>
    `,
    "features":`<p>1. Support binocular living detection</p>
    <p>2. Support human movement face tracking exposure in strong backlight environment</p>
    <p>3. Unique face recognition algorithm, accurate face recognition, face recognition time is less than 0.5s</p>
    <p>4. Integrated CPU</p>
    <p>5. H.265 video stream is directly connected to NVR and other storage devices through onvif protocol and gb28181 protocol</p>
    <p>6. Support local storage of TF card, continuous storage of pictures for 1 year, continuous storage of video for 1 month or longer (related to the capacity of optional TF Card)</p>
    <p>7. MTBF of main engine is more than 50000h</p>
    <p>8. Support temperature measurement in medium distance and high temperature alarm</p>
    <p>9. Support temperature data interface protocol docking</p>
    <p>10. Support 24000 + face comparison database and 160000 recognition records</p>
    `,
    "skus":null,
    "sonList":null
    }
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":188
    },
    // {
    // "id":1515,
    // "catName":"YF-ARC Series",
    // "catUrl":"/YF-ARC-Series-1640586544494.html",
    // "webUrl":"",
    // "sort":0,
    // "catList":[
    // ],
    // "shopList":[
    // {
    // "name":"YF-ARC-P005",
    // "img":"4edbb6748cdd86d3b15e2798c87333d.png",
    // "id":4351,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // },
    // {
    // "name":"YF-ARC-P003",
    // "img":"8c85646fe37793ed3f055d2bf4c6246.png",
    // "id":4352,
    // "url":"",
    // "webUrl":null,
    // "pId":null,
    // "sort":0,
    // "keyWords":[
    // ],
    // "describe":null,
    // "skus":null,
    // "sonList":null
    // }
    // ],
    // "img":"",
    // "seoTitle":null,
    // "seoKeyWords":null,
    // "seoDescription":null,
    // "pid":188
    // }
    ],
    "shopList":[
    ],
    "img":"",
    "seoTitle":null,
    "seoKeyWords":null,
    "seoDescription":null,
    "pid":0
    }
    ]

let footerListObj = [
    {
        "name": "YF-VEN-Y01",
        "img": "16_74caead573f74b7e9ca78fc51425b5c4.png",
        "id": 305,
        "url": "",
        "webUrl": null,
        "pId": null,
        "sort": null,
        "keyWords": null,
        "describe": "",
        "skus": null,
        "sonList": null
    },
    {
        "name": "YF-SAT-H01",
        "img": "16_b93d83e0f49246218322dac769e927d9.png",
        "id": 317,
        "url": "",
        "webUrl": null,
        "pId": null,
        "sort": null,
        "keyWords": null,
        "describe": "",
        "skus": null,
        "sonList": null
    },
    {
        "name": "YF-SAT-Y01",
        "img": "16_61aef20c059044449c1f5cf72b4d8228.png",
        "id": 319,
        "url": "",
        "webUrl": null,
        "pId": null,
        "sort": null,
        "keyWords": null,
        "describe": "",
        "skus": null,
        "sonList": null
    },
    {
        "name": "YF-JUP-T01",
        "img": "16_4052879050c34ccf9cb9f8101fdc7438.png",
        "id": 329,
        "url": "",
        "webUrl": null,
        "pId": null,
        "sort": null,
        "keyWords": null,
        "describe": "",
        "skus": null,
        "sonList": null
    }
]

export default{
    productObj,
    footerListObj
}